import { render } from "./MotmVue.vue?vue&type=template&id=26ad0e4d&scoped=true"
import script from "./MotmVue.vue?vue&type=script&lang=js"
export * from "./MotmVue.vue?vue&type=script&lang=js"

import "./MotmVue.vue?vue&type=style&index=0&id=26ad0e4d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ad0e4d"]])

export default __exports__